// extracted by mini-css-extract-plugin
export default {"error-page":"error-page--T5S11","errorPage":"error-page--T5S11","error-blurb":"error-blurb--QRMZO","errorBlurb":"error-blurb--QRMZO"};